export enum FileType {
	PDF,
	WORD,
	TEXT,
	EXCEL,
	POWERPOINT,
	JPEG,
	PNG,
	TIFF,
	RAR,
	ZIP,
}

export const FileTypeMimeTypeMap: Record<FileType, string[]> = {
	[FileType.PDF]: ['application/pdf'],
	[FileType.WORD]: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
	[FileType.TEXT]: ['application/text'],
	[FileType.EXCEL]: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
	[FileType.POWERPOINT]: [
		'application/vnd.ms-powerpoint',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	],
	[FileType.JPEG]: ['image/jpeg'],
	[FileType.PNG]: ['image/png'],
	[FileType.TIFF]: ['image/tiff'],
	[FileType.RAR]: ['application/x-rar-compressed'],
	[FileType.ZIP]: ['application/zip'],
};

export const FileTypeExtensionMap: Record<FileType, string[]> = {
	[FileType.PDF]: ['pdf'],
	[FileType.WORD]: ['doc', 'docx'],
	[FileType.TEXT]: ['txt'],
	[FileType.EXCEL]: ['xls', 'xlsx'],
	[FileType.POWERPOINT]: ['ppt', 'pptx'],
	[FileType.JPEG]: ['jpg', 'jpeg'],
	[FileType.PNG]: ['png'],
	[FileType.TIFF]: ['tif', 'tiff'],
	[FileType.RAR]: ['rar'],
	[FileType.ZIP]: ['zip'],
};
